/* eslint-disable max-statements */
import { Box, HStack, Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react';
import { CheckSquare, Square, Layers } from 'lucide-react';

import { Controller } from '@context';
import { RtaIconButton } from '@components';
import { useDesign } from '@hooks';
import {
	useBacksplashLayerFeature,
	useShowApplianceDimensionsFeature,
	useShowApplianceFeature,
	useShowApplianceLabelFeature,
	useShowBreakpointFeature,
	useShowControlsFeature,
	useShowCornerFeature,
	useShowCountertopFeature,
	useShowCutoutFeature,
	useDebugCutoutFeature,
	useShowDeveloperInsightFeature,
	useShowIslandDimensionFeature,
	useShowIslandOverlapFeature,
	useShowObstructionFeature,
	useShowOverheadDimensionFeature,
	useShowPanelInsideDimensionFeature,
	useShowPanelOutsideDimensionFeature,
	useShowTitleFeature
} from '@features';

const Checked = () => (<Box pr="5px"><CheckSquare/></Box>);
const Unchecked = () => (<Box pr="5px"><Square/></Box>);
export const LayerControls = () => {
	const [controller] = useDesign<Controller>();

	const layerFeatures = [
		useShowApplianceFeature(),
		useShowApplianceDimensionsFeature(),
		useShowApplianceLabelFeature(),
		useBacksplashLayerFeature(),
		useShowBreakpointFeature(),
		useShowCornerFeature(),
		useShowCountertopFeature(),
		useShowControlsFeature(),
		useShowCutoutFeature(),
		useShowIslandDimensionFeature(),
		useShowTitleFeature(),
		useShowIslandOverlapFeature(),
		useShowObstructionFeature(),
		useShowOverheadDimensionFeature(),
		useShowPanelInsideDimensionFeature(),
		useShowPanelOutsideDimensionFeature(),
		useShowDeveloperInsightFeature()
	];

	const debugCutout = useDebugCutoutFeature();
	const tdFeatures = [
		useShowApplianceFeature(),
		useShowCutoutFeature(),
		useShowCornerFeature(),
		useShowCountertopFeature(),
		useShowControlsFeature(),
		...(debugCutout.hidden ? [] : [debugCutout])
	];

	// set all layers enabled if every layerfeature.disable is true
	const allLayersAreDisabled = layerFeatures.every((feature) => feature.disabled);
	const controllerContext = controller?.instanceOf === 'td-controller' ? tdFeatures : layerFeatures;

	return (
		<Box w={'100%'} h={'100%'} m={'1px'} border={'0px'}>
			<HStack h={'100%'} gap={'0px'}>
				<Menu closeOnSelect={false} isLazy>
					<MenuButton as={RtaIconButton} icon={<Layers/>} enabled={!allLayersAreDisabled} label="Manage Layers"/>
					<Portal>
						<MenuList>
							{ controllerContext.map((feature) => (
								<MenuItem key={feature.name} onClick={feature.handler} isDisabled={feature.disabled}>
									{ feature.value ? <Checked/> : <Unchecked /> }{ feature.label }
								</MenuItem>))
							}
						</MenuList>
					</Portal>
				</Menu>
			</HStack>
		</Box>
	);
};
